export default {
  'PageLayoutFooter.aboutus': { en: 'About Us', fr: 'À propos de nous' },
  'PageLayoutFooter.blog': { en: 'Blog', fr: 'Blogue' },
  'PageLayoutFooter.support': { en: 'Support', fr: 'Soutien' },
};
